import { ScopedLoggerManager } from './scoped-logger-manager';

/**
 * This logger singleton is used to manage the logger manager for the core utility.
 * Added this singleton to prevent circular dependencies between utilities that rely on the logger and
 * the `getLoggerManager` function exported by `fnz-dock-core`.
 * This ensures a centralized, consistent logging mechanism without introducing dependency issues.
 */
export class CoreLogger {
  private static _loggerManager: ScopedLoggerManager;

  static get loggerManager() {
    return this._loggerManager;
  }

  static set loggerManager(manager: ScopedLoggerManager) {
    this._loggerManager = manager;
  }
}
